var metaMap = require('./_metaMap'),
    noop = require('./noop');

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_getData.js
 ** module id = 355
 ** module chunks = 0
 **/